<template>
  <div class="checkbox" :class="containerClass">
    <div class="checkbox-input-container" :class="{ 'add-check-svg': value, 'checked': value }">
      <input type="checkbox" :name="name" :id="name" :checked="value" @change="onChange">
    </div>
    <div class="checkbox-label-container">
      <label :for="name" class="checkbox-label"> 
        {{label}}
      </label>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: ['label', 'name', 'color', 'value'],
  computed: {
    containerClass () {
      return {
        'color-checked': this.color === 'checked',
      };
    },
  },
  methods: {
    onChange () {
      this.$emit('input', !this.value);
    },
  },
}
</script>

<style lang="scss" scoped>
  @import './src/var.scss';
  .checkbox {
    display: grid;
    grid-template-columns: 45px auto;

    &-input-container {
      width: 24px;
      height: 24px;
      border: 2px solid $gray;
      border-radius: 5px;
      box-sizing: content-box;
      position: relative;

      &::before {
        content: '';
				width: 22px;
				height: 22px;
				-webkit-mask-size: 21px;
				mask-size: 21px;
        position: absolute;
        z-index: -1;
        top: 2px;
        left: 1px;
      }
      &.checked {
        border-color: $pink;
        &::before {
					background-color: $pink;
				}
      }
      input[type=checkbox] {
        opacity: 0;
        width: 24px;
        height: 24px;
      }
    }
    &-label-container {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      text-align: left;
      padding: 4px 0px;
       font-size: 15px;

      > :not(:last-child) {
        margin-bottom: 10px;
      }
    }
    &.color-checked {
      .checkbox-input-container {
        border-color: $pink;
      }
    }
  }
</style>